import React, { Component } from "react";

// React router
import { withRouter } from "react-router-dom";

// Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

// Dependencies
import _ from "lodash";
import PropTypes from "prop-types";

// Material ui
import { withStyles } from "@material-ui/core";

// Shared layouts
import { Dashboard as DashboardLayout } from "layouts";
import {
  SubscriptionsList,
  SubscriptionUpgrade,
  Subscription,
  Subscription2,
  SubscriptionInvoice,
  AccessDenyPage,
  LoadingPage,
  Authorization
} from "./components";

import { fetchSubscriptions, fetchAddons, getOwnerInfo } from "../../redux/actions/subscriptionActions";

import styles from "./styles";
import { triggerBotBuilding } from "../../redux/actions/intentsActions";
import { pushMessage, removeMessage } from "../../redux/actions/commonActions";

class Subscriptions extends Component {
  signal = true;

  state = {
    isLoading: false,
    limit: 6,
    products: [],
    productsTotal: 0,
    error: null,
    search: "",
    loaded: false,
    subscriptions: {
      plans: {},
      estimate: {}
    },
    disabled: false
  };

  async getCatalog() {
    try {
      this.setState({ isLoading: true });
      await this.props.fetchSubscriptions();
      await this.props.fetchAddons();
      this.setState({ isLoading: false, loaded: true });
    } catch (error) {
      if (this.signal) {
        this.setState({
          isLoading: false,
          loaded: true,
          error
        });
      }
    }
  }

  componentWillMount() {
    this.signal = true;
    this.getCatalog();
  }

  componentWillUnmount() {
    this.signal = false;
  }

  componentWillReceiveProps(newProps, oldProps) {
    this.setState({ subscriptions: newProps.subscriptions });
  }

  onBuildBotClick = () => {
    this.setState({ disabled: true });
    this.props.triggerBotBuilding();
  };

  // render() {
  //     const { classes } = this.props;

  //     const enabled = this.state.subscriptions["enabled"] ? this.state.subscriptions.enabled : [];
  //     const common = this.state.subscriptions["common"] ? this.state.subscriptions.common : [];

  //     return (
  //         <DashboardLayout title="Subscriptions" isLoading={this.state.isLoading}>
  //             <Grid spacing={2} container>
  //                 <Grid item xs={12} sm={9} />
  //                 <Divider className={classes.divider} />
  //                 <Grid item xs={12}>
  //                     <div className={classes.listClass}>
  //                         <SubscriptionsList subscriptions={enabled} enabled={enabled} name={"Active Subscriptions"} showBadge={true} />
  //                     </div>
  //                 </Grid>
  //                 <Divider className={classes.divider} />
  //                 <Grid item xs={12}>
  //                     <div className={classes.listClass}>
  //                         <SubscriptionsList subscriptions={common} enabled={enabled} name={"Available Subscriptions"} />
  //                     </div>
  //                 </Grid>
  //             </Grid>
  //         </DashboardLayout>
  //     );
  // }

  renderSubscription() {
    const { classes } = this.props;

    const enabled = this.state.subscriptions.plans["enabled"] ? this.state.subscriptions.plans.enabled : [];
    const common = this.state.subscriptions.plans["common"] ? this.state.subscriptions.plans.common : [];
    const estimate = this.state.subscriptions.estimate ? this.state.subscriptions.estimate : {};
    const payment_intent = this.state.subscriptions.payment_intent ? this.state.subscriptions.payment_intent : {};
    const addons = this.state.subscriptions.addons ? this.state.subscriptions.addons : {};
    const license = this.state.subscriptions.license ? this.state.subscriptions.license : {};
    console.log("SUBSCRIPTIONS", this.state.subscriptions);

    return (
      <Subscription
        transaction={this.state.subscriptions.transaction}
        subscriptions={common}
        estimate={estimate}
        payment_intent={payment_intent}
        addons={addons}
        plans={common}
        license={license}
      />
      // <AccessDenyPage></AccessDenyPage>
    );
  }

  renderAccessDeny() {
    return <AccessDenyPage ownerInfo={this.state.ownerInfo} />;
  }

  render() {
    if (!this.state.pageToRender) {
      return <LoadingPage />;
    }
    // if (this.state.pageToRender === "deny") return this.renderAccessDeny();
    // return this.renderSubscription();
    if (Authorization.Check("purchase_license")) return this.renderSubscription();
    else return this.renderAccessDeny();
  }

  fillOwnerInfo(username) {
    const data = {
      method: "getOwnerInfo",
      params: {
        username: username
      }
    };
    this.props.getOwnerInfo(data).then(result => {
      console.log("OwnerInfo", result);
      if (result.isOwner) {
        this.setState({ pageToRender: "allow", ownerInfo: result.data });
      } else {
        this.setState({ ownerInfo: result.data, pageToRender: "deny" });
      }
    });
  }

  componentDidMount() {
    this.fillOwnerInfo(this.props.cognitoUser.username);
    Authorization.SetRoles(_.get(this.props.cognitoUser.attributes, "custom:role", "user"));
  }
}

Subscriptions.propTypes = {
  classes: PropTypes.object.isRequired,
  fetchSubscriptions: PropTypes.func,
  getOwnerInfo: PropTypes.func
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    subscriptions: state.subscriptions ? state.subscriptions : {},
    skill: state.skill,
    botBuilt: state.intents["botBuilt"] ? state.intents.botBuilt : {},
    botStatus: state.intents["botStatus"] ? state.intents.botStatus : {},
    botBuildTriggered: state.intents["botBuildTriggered"] ? state.intents.botBuildTriggered : false,
    message: state.common.message,
    administrator: _.get(state.auth.cognitoUser.attributes, "custom:role", "user") === "Administrator"
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        getOwnerInfo,
        fetchSubscriptions,
        fetchAddons,
        triggerBotBuilding,
        removeMessage,
        pushMessage
      },
      dispatch
    ),
    dispatch
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Subscriptions))
);
